import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';

import styles from './kanban.module.css';

const Kanban = ( { data, mapCards } ) => {
	const renderColumns = useCallback(
		() => data.map( ( { column } ) => <Grid.Column key={ column.title } className={ styles.header }>
			<h4>{ column.title }</h4>
		</Grid.Column> ),
		[ data ]
	);

	const renderCards = useCallback(
		() => data.map( ( { column, cards } ) => (
			<Grid.Column
				key={ column.title }
				className={ styles.cards }
			>
				<div className={ styles.columnContent }>
					{ mapCards( cards ) }
				</div>
			</Grid.Column>
		) ),
		[ data, mapCards ]
	);

	return (
		<div className={ styles.kanban }>
			<Grid
				className={ styles.grid }
				columns="equal"
				inverted={ false }
			>
				<Grid.Row color="pink">
					{ renderColumns() }
				</Grid.Row>
				<Grid.Row className={ styles.cardsRow }>
					{ renderCards() }
				</Grid.Row>
			</Grid>
		</div>
	);
};

Kanban.propTypes = {
	data: PropTypes.arrayOf( PropTypes.shape( {
		column: PropTypes.object,
		cards: PropTypes.array
	} ) ),
	mapCards: PropTypes.func
};

export default Kanban;
